module.exports = __webpack_public_path__ + "static/media/video-camera.fa37cbad.svg";